import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

import { ref, toRefs, onMounted, watch } from 'vue';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any[];
  dataKey: string;
  itemSize: number;
  poolBuffer: number;
}

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    data: { default: () => [] },
    dataKey: { default: 'id' },
    itemSize: { default: 40 },
    poolBuffer: { default: 50 }
  },
  setup(__props: any) {

const props = __props as { data: any[], dataKey: string, itemSize: number, poolBuffer: number }



const { data, poolBuffer, itemSize } = toRefs(props);
const root = ref<HTMLElement | null>(null);
const pool = ref<Props['data']>([]);
const scrollHeight = ref(data.value.length * itemSize.value);

watch(
  data,
  (cData) => {
    scrollHeight.value = cData.length * itemSize.value;
  },
  { deep: true }
);
watch(itemSize, (cItemSize) => {
  scrollHeight.value = data.value.length * cItemSize;
});

let containerSize = 0;

const paddingTop = ref(0);

let isScrollBusy = false;

const handleScroll = () => {
  if (!root.value) return;
  if (isScrollBusy) return;
  isScrollBusy = true;
  requestAnimationFrame(() => {
    isScrollBusy = false;
    if (!root.value) return;
    const range: number[] = [];
    range[0] =
      Math.floor(root.value.scrollTop / itemSize.value) -
      Math.floor(poolBuffer.value / 2);
    range[0] = Math.max(range[0], 0);
    range[1] =
      range[0] +
      Math.floor(root.value.clientHeight / itemSize.value) +
      poolBuffer.value;
    range[1] = Math.min(range[1], data.value.length);
    pool.value = data.value
      .slice(range[0], range[1])
      .map((v, i) => ({ ...v, _index: range[0] + i }));
    paddingTop.value = range[0] * itemSize.value;
  });
};

onMounted(() => {
  if (!root.value) return;
  containerSize = root.value.clientHeight;
  const contentLines = Math.ceil(containerSize / itemSize.value);
  const totalLines = contentLines + poolBuffer.value;
  const range = [0, totalLines];
  pool.value = data.value
    .slice(range[0], range[0] + range[1])
    .map((v, i) => ({ ...v, _index: range[0] + i }));
  setTimeout(handleScroll, 500);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "virtual-list-container",
    ref: (_value, _refs) => {
      _refs['root'] = _value
      root.value = _value
    },
    onScrollPassive: handleScroll
  }, [
    _createElementVNode("div", {
      class: "virtual-list-scroll",
      style: _normalizeStyle(`height: ${scrollHeight.value}px;padding-top: ${paddingTop.value}px`)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pool.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "virtual-list-item-container",
          key: item[__props.dataKey],
          style: _normalizeStyle(`height: ${_unref(itemSize)}px`)
        }, [
          _renderSlot(_ctx.$slots, "default", {
            item: item,
            index: item._index
          })
        ], 4))
      }), 128))
    ], 4)
  ], 544))
}
}

})